module.exports = __webpack_public_path__ + "static/media/leptophyes_punctatissima_002_APA.dd2979dd.mp3";